import { Component } from '@angular/core'
import {
  IonHeader,
  IonToolbar,
  IonTitle,
  IonContent,
  IonGrid,
  IonRow,
  IonItem,
  IonCheckbox,
  IonLabel,
  IonButton,
  IonCol,
  IonFooter,
} from '@ionic/angular/standalone'
import { TranslateModule } from '@ngx-translate/core'

import {
  CookiesService,
  CoookiesState,
} from 'src/app/services/internal/cookies.service'

export enum CookieManagementState {
  Initial = 'initial',
  Managing = 'managing',
}

@Component({
  selector: 'app-cookies',
  imports: [
    TranslateModule,
    IonGrid,
    IonRow,
    IonItem,
    IonCheckbox,
    IonButton,
    IonCol,
    IonFooter,
  ],
  templateUrl: './cookies.component.html',
  styleUrls: ['./cookies.component.scss'],
})
export class CookiesComponent {
  CookieManagementState = CookieManagementState
  modal: HTMLIonModalElement | null
  analyticsAccepted: 'true' | 'false' = 'false'
  protected currentState = CookieManagementState.Initial

  constructor(private cookiesService: CookiesService) {
    this.initializeState()
  }

  private initializeState() {
    const state = this.cookiesService.cookiesState()
    if (state.state === 'already_set') {
      this.analyticsAccepted = state.preferences.analytics ? 'true' : 'false'
      this.currentState = CookieManagementState.Managing
    }
  }

  updateFixedValue() {
    this.currentState = CookieManagementState.Managing
    this.modal = document.querySelector('#ecl-cookies-modal')
    this.modal?.classList.add('fullHeight')
  }

  checkBoxChanged(event: any) {
    this.analyticsAccepted = event.detail.checked ? 'true' : 'false'
  }

  checkAnalyticsAndClose() {
    const preferences = {
      necessary: true,
      analytics: this.analyticsAccepted === 'true',
    }
    this.cookiesService.storePreferences(preferences)
    this.modal?.dismiss()
  }

  acceptAll() {
    const preferences = {
      necessary: true,
      analytics: true,
    }
    this.cookiesService.storePreferences(preferences)
    this.modal?.dismiss()
  }
}
